import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { useProjectT } from 'services/ProjectLabels'
import { AppMode, PreviewMode } from 'services/Store/Project/enums'
import { useGetEntityAnalyticsConfig } from 'services/lms/hooks/useGetEntityAnalyticsConfig'
import { testProps } from 'utils/test/qaData'
import { prepareLinkUrl } from 'utils/websiteValidation'

import { useElementCompleted } from '../../hooks/useElementCompleted'
import { useElementRootStyles } from '../../hooks/useElementRootStyles'
import * as s from './LinkElement.module.scss'
import { PreviewCard } from './PreviewCard'
import { labelFromUrl } from './helper'
import type { LinkElementType } from './linkTypes'
import LinkStyled from './styled/LinkStyled'
import RootLinkStyled from './styled/RootLinkStyled'

const LinkElement: LinkElementType = ({
  element: { value, id },
  styles,
  mode,
  font,
  block,
  isV2,
}) => {
  const pt = useProjectT()
  const { showPreview, linkLabel, linkURL, target = '_blank' } = value
  const disabled = mode.previewMode === PreviewMode.editor || mode.editorMode === AppMode.comment
  const correctLink = linkURL && prepareLinkUrl(linkURL || '')
  const linkURLValueByMode = disabled ? undefined : correctLink

  const rootStyles = useElementRootStyles(styles.root)
  const existingLabel = linkLabel || labelFromUrl(linkURL)
  const setCompleted = useElementCompleted({
    block,
    elementId: id,
    deviceMode: mode.deviceMode,
    completed: false,
  })
  const { entityAnalyticsConfig, sendXapiData, baseObjectExtensions } = useGetEntityAnalyticsConfig(
    {
      blockId: block?.uuid || '',
      elementType: CONFIG_ELEMENTS.link.type,
      elementId: id,
    },
  )

  return (
    <RootLinkStyled
      $placeholder={!linkLabel}
      href={linkURLValueByMode}
      onClick={() => {
        setCompleted(Boolean(linkURLValueByMode))
        const data = entityAnalyticsConfig?.interacted({
          resultExtensions: { elementUrl: linkURLValueByMode },
          objectExtensions: baseObjectExtensions,
          elementId: id,
        })
        sendXapiData(data)
      }}
      rel='noreferrer'
      style={rootStyles}
      target={target}
      {...testProps({ el: 'linkEl', value: linkURL, label: linkLabel })}
    >
      <LinkStyled $font={font} $label={existingLabel}>
        <span className={s.linkIcon}>
          {styles.icon.backgroundImage ? (
            <div className={s.icon} style={styles.icon} />
          ) : (
            <Icon name='link2' size={KitSize.M} aria-hidden />
          )}
        </span>
        <span>{existingLabel || pt('elements.link.placeholder')}</span>
      </LinkStyled>
      {showPreview && (
        <PreviewCard
          {...value}
          deviceMode={mode.deviceMode}
          font={font}
          isV2={isV2}
          styles={styles}
        />
      )}
    </RootLinkStyled>
  )
}

export default LinkElement
